var map = {
	"./__branding.gif": 3784,
	"./__drop_racing.jpg": 9108,
	"./__fawna.jpg": 9900,
	"./__fish.jpg": 5300,
	"./__freebies.jpg": 5080,
	"./__headbanging_bird.jpg": 7752,
	"./__illustrations.gif": 8364,
	"./__respira.jpg": 8909,
	"./__sardinhas.jpg": 8244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4520;